app.factory("LecturerService", [
    "$http",
    function ($http) {
        var LecturerService = {};

        LecturerService.subjectList = function (params) {
            var lecturerId = params.lecturerId;
            return $http.post("/grade/subject/list", {lecturerId: lecturerId}).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.subjectGroups = function (params) {
            var lecturerId = params.lecturerId;
            var subjectId = params.subjectId;
            return $http.post("/grade/subject/groups", {
                lecturerId: lecturerId,
                subjectId: subjectId
            }).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.selectionList = function (params) {
            var paramsObject = {
                lecturerId: params.lecturerId,
                subjectId: params.subjectId,
                sessionGroup: params.sessionGroup || null
            };
            return $http.post("/grade/selection/list/", paramsObject).then(function (resp) {
                var data = resp.data;
                var selections = data.subjectSelections;
                var gradeTemplate = data.gradeTemplate;
                var grades = data.grades;
                var subject = data.subject;
                selections.forEach(function (selection) {
                    var finalGradeList = [];
                    var selectionGrades = grades.filter(function (e) {
                        return e.subjectSelection === selection._id
                    });
                    gradeTemplate.components.forEach(function (component) {
                        var cloned = _.cloneDeep(component);
                        if (cloned.type !== "group") {
                            var elems = selectionGrades.filter(function (e) {
                                return e.gradeComponent === component._id
                            });
                            if (elems.length > 0) {
                                cloned.grade = elems[0];
                            } else {
                                cloned.grade = null;
                            }
                            cloned.selection = selection._id;
                        }
                        finalGradeList.push(cloned);
                    });

                    finalGradeList.map(function (el) {
                        el.inlineValue = el.grade ? el.grade.absolute : "-";
                    });

                    var masterLayer = finalGradeList.filter(function (e) {
                        return e.parent === null;
                    });
                    masterLayer.map(function (el) {
                        var written = 0;
                        if (el.type === "group") {
                            written = 0;
                            el.items = finalGradeList.filter(function (e) {
                                return e.parent === el._id;
                            });
                            el.inlineValue = _.sumBy(el.items, function (o) {
                                written = written + (o.grade ? 1 : 0);
                                return o.grade ? o.grade.absolute : 0;
                            });
                            el.inlineValue = written > 0 ? Math.round(el.inlineValue*100)/100 : "-";

                        }
                    });


                    selection.grades = masterLayer;
                    selection.unorderedGrades = finalGradeList;

                });
                return {subject: subject, selections: selections, gradeTemplate: gradeTemplate};
            });
        };

        LecturerService.exportSelectionStudents = function (params) {
            var url = "/grade/selection/list/export?";

            for (var i in params) {
                if (typeof params[i] === 'string')
                    url += i + "=" + params[i] + "&"
                else params[i].forEach(function (m) {
                    url += i + "=" + m + "&"
                })
            }
            url = url.substr(0, url.length - 1);
            window.open(url, "_blank");
        };

        LecturerService.create = function (params) {
            var gradeTemplateObject = {
                name: params.name,
                code: params.code
            };
            return $http.post("/grade-template/create", gradeTemplateObject).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.addGrade = function (params) {

            var gradeObject = {
                lecturerId: params.lecturerId,
                gradeComponent: params.gradeComponent,
                relative: params.relative,

                subjectSelection: params.subjectSelection
            };
            return $http.post("/grade/grade/add", gradeObject).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.editGrade = function (params) {

            var gradeComponentObject = {
                grade: params.grade,
                lecturerId: params.lecturerId,
                relative: params.relative,
                comment: params.comment
            };
            return $http.post("/grade/grade/edit", gradeComponentObject).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.post = function (params) {
            return $http.post("/grade/subject/groups/posts", params).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.setConsultations = function (profileId, value) {
            return $http.post("/lecturer/consultations", {
                profileId,
                value
            }).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.editConsultations = function (id, value) {
            return $http.put("/lecturer/consultations", {
                _id: id,
                value
            }).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.getConsultations = function (profileIds) {
            return $http.get("/lecturer/consultations", {
                params: {profileIds: profileIds}
            }).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.blockGrade = function (params) {
            return $http.post("/grade/grade/lock", params).then(function (resp) {
                return resp.data;
            });
        };

        LecturerService.unblockGrade = function (grade) {
            return $http.post("/grade/grade/unlock", grade).then(function (resp) {
                return resp.data;
            });
        };

        return LecturerService;
    }
]);
